import React from "react";
import PublicNavbar from "@/components/PublicNavbar";
import PublicFooter from "@/components/PublicFooter";
import WhatsAppButton from "@/components/WhatsAppButton";
import { FileText } from "lucide-react";

export default function Terms() {
  return (
    <div className="min-h-screen bg-white">
      <PublicNavbar />
      <section className="bg-gradient-to-b from-blue-50/60 to-white border-b border-slate-200 py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-blue-50 border border-blue-200 text-brand text-xs font-bold">
            <FileText size={14} /> Legal
          </div>
          <h1 className="heading mt-5 text-4xl sm:text-5xl font-black">Terms &amp; Conditions</h1>
          <p className="mt-3 text-slate-600">Last updated: April 2026</p>
        </div>
      </section>
      <section className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="space-y-6 text-slate-700 leading-relaxed">
          <p>Welcome to PMR Welfare Foundation. By accessing or using our website <b>pmrwelfarefoundation.in</b> and related services, you agree to these Terms &amp; Conditions.</p>

          <H>1. About Us</H>
          <p>PMR Welfare Foundation is a Section 8 Company registered under the Companies Act, 2013 (CIN: <b>U84120BR2024NPL067860</b>), NGO Darpan ID <b>BR/2024/0396082</b>, 80G-registered under <b>AAOCP5008QF20251</b>, with its registered office at Ram Shyam Niketan Apartment, Nehru Nagar Rd, near Patliputra Police Station, Patna, Bihar 800001, India.</p>

          <H>2. Use of the Platform</H>
          <ul className="list-disc list-outside ml-6 space-y-2">
            <li>You must provide accurate information during registration.</li>
            <li>You are responsible for maintaining the confidentiality of your account and password.</li>
            <li>You must not attempt to disrupt our services, tamper with exams, impersonate others, or engage in any fraudulent activity.</li>
            <li>Age requirement: 13+ for student accounts (with parental consent if below 18).</li>
          </ul>

          <H>3. Donations</H>
          <ul className="list-disc list-outside ml-6 space-y-2">
            <li>All donations are voluntary and intended for the charitable objectives of the Foundation.</li>
            <li>Payments are processed via <b>PayU</b>; we do not store card/UPI credentials.</li>
            <li>Donations are eligible for tax deduction under Section 80G of the Income Tax Act (AAOCP5008QF20251), subject to Indian tax law.</li>
            <li>Receipts are emailed automatically; in exceptional cases up to 48 hours after successful payment.</li>
          </ul>

          <H>4. Internships &amp; Test Series</H>
          <ul className="list-disc list-outside ml-6 space-y-2">
            <li>Internships are awarded at the sole discretion of PMR Welfare Foundation based on the applicant's profile.</li>
            <li>Certificates are issued only upon successful completion of the program.</li>
            <li>Test-series fees (if any) grant you one attempt per test unless stated otherwise.</li>
            <li>Any proven malpractice during an exam will lead to immediate disqualification.</li>
          </ul>

          <H>5. Intellectual Property</H>
          <p>All content on this website — logo, text, images, curricula, videos — is the property of PMR Welfare Foundation, except where attributed. You may not reproduce, distribute or create derivative works without prior written permission.</p>

          <H>6. Limitation of Liability</H>
          <p>The services are provided on an "as is" and "as available" basis. PMR Welfare Foundation is not liable for indirect, incidental or consequential damages arising from your use of the platform.</p>

          <H>7. Governing Law</H>
          <p>These Terms are governed by the laws of India. Any disputes shall be subject to the exclusive jurisdiction of the courts at Patna, Bihar.</p>

          <H>8. Modifications</H>
          <p>We may revise these Terms at any time. Continued use of the services after revisions constitutes acceptance of the updated Terms.</p>

          <H>9. Contact</H>
          <p>For questions: <a className="text-brand font-bold" href="mailto:contact@pmrwelfarefoundation.in">contact@pmrwelfarefoundation.in</a> · <b>+91 9155561892</b></p>
        </div>
      </section>
      <PublicFooter contact={null} />
      <WhatsAppButton />
    </div>
  );
}

function H({ children }) { return <h2 className="heading text-2xl font-black text-brand pt-4">{children}</h2>; }
